import { apiClient } from './api';

export const remediationApi = {
  // Auto-generate remediation recommendations for an incident
  autoGenerateRecommendations: async (incidentId) => {
    const response = await apiClient.post(`/incidents/${incidentId}/remediation-recommendations`);
    return response.data;
  },

  // Get all remediation recommendations for an incident
  getIncidentRecommendations: async (incidentId) => {
    const response = await apiClient.get(`/incidents/${incidentId}/remediation-recommendations`);
    return response.data;
  },

  // Approve a remediation recommendation
  approveRecommendation: async (recommendationId, approver) => {
    const response = await apiClient.put(`/remediation-recommendations/${recommendationId}/approve`, null, {
      params: { approver }
    });
    return response.data;
  },

  // Reject a remediation recommendation
  rejectRecommendation: async (recommendationId, rejector, reason) => {
    const response = await apiClient.put(`/remediation-recommendations/${recommendationId}/reject`, null, {
      params: { rejector, reason }
    });
    return response.data;
  },

  // Execute a remediation recommendation
  executeRecommendation: async (recommendationId, executor) => {
    const response = await apiClient.post(`/remediation-recommendations/${recommendationId}/execute`, null, {
      params: { executor }
    });
    return response.data;
  },

  // Complete execution of a remediation recommendation
  completeExecution: async (recommendationId, success, executionTimeMinutes, feedback = null) => {
    const response = await apiClient.put(`/remediation-recommendations/${recommendationId}/complete`, null, {
      params: { 
        success, 
        execution_time_minutes: executionTimeMinutes,
        feedback
      }
    });
    return response.data;
  },

  // Create mock remediation data
  createMockData: async () => {
    const response = await apiClient.post('/mock-data/remediation');
    return response.data;
  }
};

// Constants for remediation management
export const REMEDIATION_TYPES = {
  IMMEDIATE_FIX: 'IMMEDIATE_FIX',
  PREVENTIVE_MEASURE: 'PREVENTIVE_MEASURE',
  ROLLBACK_PROCEDURE: 'ROLLBACK_PROCEDURE',
  MONITORING_ENHANCEMENT: 'MONITORING_ENHANCEMENT',
  CONFIGURATION_CHANGE: 'CONFIGURATION_CHANGE',
  SCRIPT_EXECUTION: 'SCRIPT_EXECUTION',
  DEPLOYMENT_ACTION: 'DEPLOYMENT_ACTION'
};

export const REMEDIATION_STATUSES = {
  GENERATED: 'GENERATED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  ROLLED_BACK: 'ROLLED_BACK'
};

export const REMEDIATION_PRIORITIES = {
  CRITICAL: 'CRITICAL',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW'
};

export const STATUS_LABELS = {
  [REMEDIATION_STATUSES.GENERATED]: 'Generated',
  [REMEDIATION_STATUSES.PENDING_APPROVAL]: 'Pending Approval',
  [REMEDIATION_STATUSES.APPROVED]: 'Approved',
  [REMEDIATION_STATUSES.REJECTED]: 'Rejected',
  [REMEDIATION_STATUSES.IN_PROGRESS]: 'In Progress',
  [REMEDIATION_STATUSES.COMPLETED]: 'Completed',
  [REMEDIATION_STATUSES.FAILED]: 'Failed',
  [REMEDIATION_STATUSES.ROLLED_BACK]: 'Rolled Back'
};

export const TYPE_LABELS = {
  [REMEDIATION_TYPES.IMMEDIATE_FIX]: 'Immediate Fix',
  [REMEDIATION_TYPES.PREVENTIVE_MEASURE]: 'Preventive Measure',
  [REMEDIATION_TYPES.ROLLBACK_PROCEDURE]: 'Rollback Procedure',
  [REMEDIATION_TYPES.MONITORING_ENHANCEMENT]: 'Monitoring Enhancement',
  [REMEDIATION_TYPES.CONFIGURATION_CHANGE]: 'Configuration Change',
  [REMEDIATION_TYPES.SCRIPT_EXECUTION]: 'Script Execution',
  [REMEDIATION_TYPES.DEPLOYMENT_ACTION]: 'Deployment Action'
};